import React from 'react';
import PropTypes from 'prop-types';
import { Input as StyledInput } from '../style';
import Label from '../Label';

const Input = ({
	id,
	name,
	type,
	label,
	value,
	placeholder,
	onChange,
	padding,
	fontSize,
	borderradius,
    lineheight,
    theme,
}) => (
	<>
		{label && (<Label theme={theme} id={id}>{label}</Label>)}
		<StyledInput
			id={id}
			name={name}
			type={type}
			value={value}
			placeholder={placeholder}
			onChange={onChange}
			padding={padding}
			fontSize={fontSize}
			borderradius={borderradius}
			lineheight={lineheight}
			theme={theme}
		/>
	</>
);

PropTypes.Input = {
	id: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]).isRequired,
	name: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	placeholder: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	padding: PropTypes.string,
	fontSize: PropTypes.string,
	borderradius: PropTypes.string,
    lineheight: PropTypes.string,
    theme: PropTypes.string,
};

export default Input;
